export default __webpack_public_path__ + "static/media/move-disabled.792539bb.svg";